import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tick2",
  "use": "icon-tick2-usage",
  "viewBox": "0 0 28.85 23.75",
  "content": "<symbol viewBox=\"0 0 28.85 23.75\" id=\"icon-tick2\">\r\n    <path d=\"M8.21,23.87.86,16.53A2,2,0,0,1,3.69,13.7l4.52,4.52L25.71.71a2,2,0,0,1,2.83,2.83Z\" transform=\"translate(-0.28 -0.13)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/tick2.svg
// module id = 1Di1
// module chunks = 0